var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10837.269 3546.896 1697.631 951.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".adot{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 -96)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(11181.241 3989.871) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11499.059, 4140.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11282.763, 3791.985)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(11449.809 4319.723) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11055.652, 4117.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11246.516, 4152.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11364.088 4129.743) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11132.471 3843.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(11336.253 3913.266) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 10998.874, 3782.972)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 10988.961, 3962.318)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11075.693 3657.496) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(10935.204 3642.896) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 10838.455, 3828.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11595.705 4017.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11657.676, 4300.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(11755.327 4115.143) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11714.453, 4446.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(11868.882 4285.476) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11745.705 4017.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11502.516, 3912.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11915.088 4010.743) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11697.693 3861.496) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(12020.204 4170.896) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11282.652, 4276.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11601.471 4168.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12066.471 4292.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11847.471 4423.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11890.516, 4152.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(12077.204 3981.896) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11875.471 3869.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 12160.961, 4104.317)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 12197.455, 4200.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 11976.676, 4334.28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(12074.809 4422.723) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(12232.253 4327.266) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12260.705 4031.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12124.471 3888.15) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 12317.455, 4140.935)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(11426.705 4033.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12378.705 4250.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12391.705 4044.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(12436.705 4143.99) rotate(7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(12331.204 4346.896) rotate(28)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "adot",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 12250.059, 4473.762)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b450d52a309b1edcbd73272c6af3098e.svg";
export { ForwardRef as ReactComponent };